module.exports = __webpack_public_path__ + "static/media/brand-story-meaning12.912ce3a3.png";